var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"header":_vm.$t('selectedSpace'),"loading":_vm.loading}},[_c('div',{staticClass:"row"},[_c('SpaceSwitch',{staticClass:"col-sm-12",attrs:{"disabled":_vm.disabled},on:{"loading":_vm.onLoading,"spaceId":_vm.onSpaceId,"space":_vm.onSpace}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }